import React, {useEffect, useState} from "react";
import { Link, useLocation } from "react-router-dom";
import { clearLocalStorageItems } from './common/Functions';
import { useAuth0 } from "@auth0/auth0-react";
import { is } from "date-fns/locale";

import { ReactComponent as AskIcon } from '../images/v2/nav/ask.svg';
import { ReactComponent as ChannelIcon } from '../images/v2/nav/channel.svg';
import { ReactComponent as CommunityIcon } from '../images/v2/nav/forum.svg';
import { ReactComponent as KnowledgeIcon } from '../images/v2/nav/ks.svg';
import { ReactComponent as ReportingIcon } from '../images/v2/nav/reporting.svg';
import { ReactComponent as ResponseIcon } from '../images/v2/nav/response.svg';
import { ReactComponent as UserIcon } from '../images/v2/nav/user.svg';


import { ReactComponent as AskIconHover } from '../images/v2/nav/white/ask.svg';
import { ReactComponent as ChannelIconHover } from '../images/v2/nav/white/channel.svg';
import { ReactComponent as CommunityIconHover } from '../images/v2/nav/white/forum.svg';
import { ReactComponent as KnowledgeIconHover } from '../images/v2/nav/white/ks.svg';
import { ReactComponent as ReportingIconHover } from '../images/v2/nav/white/reporting.svg';
import { ReactComponent as ResponseIconHover } from '../images/v2/nav/white/response.svg';
import { ReactComponent as UserIconHover } from '../images/v2/nav/white/user.svg';


function SideBarNav(props) {
    const { logout, user } = useAuth0();
    const location = useLocation();
     const [isAdmin, setIsAdmin] = useState(false);

    const handleNavToggle = (e) => {
        e.preventDefault();
        props.setIsSidebarActive((prev) => !prev);
      };

    useEffect(() => {
        if (user) {
            const roles = user?.ept_roles;
            if (roles && roles.includes('Admin')) {
                setIsAdmin(true);
            }
        }
      }, [user]);
      
  return (
    
    <div className="sidebar-nav">
        <div className="sidebar-inner">
            <a href="#" className="nav-toggle-btn" onClick={(e)=> handleNavToggle(e)}></a>
            <Link to="/" className="sidebar-logo">
                <span className="sidebar-logo-img"></span>
            </Link>
            
                <div className="nav-scroll">
                <div className="upper-nav">
                        <div className="side-nav-heading">Accounts</div>
                        {isAdmin && (
                            <>
                        <Link to="/" className={`${location.pathname === '/' ? 'active' : ''}`}>
                        <i className="fa-solid fa-address-card" style={{marginRight:'10px', verticalAlign:'5px'}}></i><span>Accounts</span>
                        </Link>
                        <Link to="/company" className={`companies-btn ${location.pathname === '/company' ? 'active' : ''}`}>
                        <i className="fa-solid fa-address-card" style={{marginRight:'10px', verticalAlign:'5px'}}></i><span>Companies</span>
                        </Link>
                        </>
                        )}
                        <Link to="/deal-rooms" className={`deal-rooms-btn ${location.pathname === '/deal-rooms' ? 'active' : ''}`}>
                            <i className="fa-solid fa-address-card" style={{marginRight:'10px', verticalAlign:'5px'}}></i><span>Deal Rooms</span>
                        </Link>
                    </div>

                    {isAdmin && (
                        
                        <div className="upper-nav">
                            <div className="side-nav-heading">Channels & Knowledge</div>
                            <Link to="/channel" className={`channel-btn ${location.pathname === '/channel' ? 'active' : ''}`}>
                                <ChannelIcon  className="sidebar-icons-hover"  />
                                <ChannelIconHover className="sidebar-icons" />
                                <span>Channel Management</span>
                            </Link>
                            <Link to="/ks" className={`ks-btn ${location.pathname === '/ks' || location.pathname.startsWith('/ks/') ? 'active' : ''}`}>
                                <KnowledgeIcon className="sidebar-icons-hover" />
                                <KnowledgeIconHover className="sidebar-icons" />
                                <span>Knowledge Sources</span>
                            </Link>
                            <Link to="/ksc" className={` ksc-btn ${location.pathname.startsWith('/ksc') ? 'active' : ''}`}>
                                <KnowledgeIcon className="sidebar-icons-hover" />
                                <KnowledgeIconHover className="sidebar-icons" />
                                <span>Knowledge Source Configurations</span>
                            </Link>
                        </div>

                        
                    )}
                    <div className="upper-nav">
                        <div className="side-nav-heading">AI Performance Management</div>
                        {isAdmin && (
                            <>
                            <Link to="/recommendations" className={`${(location.pathname === '/recommendations' || location.pathname.startsWith('/recommendation/')) ? 'active' : ''}`}>
                                <i className="fa-regular fa-lightbulb" style={{marginRight:'10px', verticalAlign:'5px'}}></i>
                                <span>Recommendations</span>
                            </Link>
                            <Link to="/ai-guidance" className={`${location.pathname === '/ai-guidance' ? 'active' : ''}`}>
                                <i className="fa-solid fa-robot" style={{marginRight:'10px', verticalAlign:'5px'}}></i>
                                <span>AI Guidance</span>
                            </Link>
                            <Link to="/conversations" className={`response-btn ${location.pathname === '/conversations' ? 'active' : ''}`}>
                                <ResponseIcon className="sidebar-icons-hover" />
                                <ResponseIconHover className="sidebar-icons" />
                                <span>Conversations</span>
                            </Link>
                        <Link to="/response" className={`response-btn ${location.pathname === '/response' ? 'active' : ''}`}>
                            <ResponseIcon className="sidebar-icons-hover" />
                            <ResponseIconHover className="sidebar-icons" />
                            <span>Responses</span>
                        </Link>
                        
                        <Link to="/reporting" className={`analysis-btn ${location.pathname === '/analysis' ? 'active' : ''}`}>
                            <ReportingIcon className="sidebar-icons-hover" />
                            <ReportingIconHover className="sidebar-icons" />
                            <span>Reporting</span>
                        </Link>
                        </>
                        )}
                    </div>
                    
                    {isAdmin && (
                        <div className="upper-nav">
                            <div className="side-nav-heading">Experiments</div>
                            <Link to="/query-builder" className={`${location.pathname === '/query-builder' ? 'active' : ''}`}>
                                <i className="fa-solid fa-database" style={{marginRight:'10px', verticalAlign:'5px'}}></i>
                                <span>Query Builder</span>
                            </Link>
                        </div>
                    )}
                    
                    <div className="upper-nav">
                        <div className="side-nav-heading">User Management</div>
                        {isAdmin && (
                        <>
                        <Link to="/users" className={`user-btn ${location.pathname === '/users' ? 'active' : ''}`}>
                            <UserIcon className="sidebar-icons-hover" />
                            <UserIconHover className="sidebar-icons" />
                            <span>Users</span>
                        </Link>
                        </>
                        )}
                        <a className="logout-btn" href="#">
                {user && (
                  <>
                    <img
                      className="profile-avatar"
                      src={user.picture}
                      alt={user.name}
                    />
                    <div className="sidebar-user">
                      {/* <span className='sidebar-user-text'>{user.name}</span> */}
                      <span className="sidebar-user-text">
                        {user.email}
                      </span>
                    </div>
                  </>
                )}
                <span
                  className="logout-after"
                  onClick={() => {
                    // check if itme exist in local storage
                    clearLocalStorageItems();
                    localStorage.removeItem('redirectPath');
                    logout({
                      logoutParams: { returnTo: window.location.origin },
                    });
                  }}
                ></span>
              </a>
                    </div>
                    
            </div>
            
            {/* <div className="lower-nav">
                <div className="nav-item">
                    <i className="fas fa-sign-out-alt"></i>
                    <span>Logout</span>
                </div>  
            </div> */}
        </div>
    </div>
    
    );
}

export default SideBarNav;